<section class="w-full h-full bg-main-blue-light md:px-10 md:py-16 px-4 py-8">
  <div class="container mx-auto w-full h-full">
    <div
      appScrollAnimate="animate-fade-in-up"
      [scrollThreshold]="0"
      class="flex flex-col items-center justify-center py-10 text-white md:gap-15 gap-8"
    >
      <h2
        i18n="organizer.grow|Manage smarter tagline@@organizer.grow.manageSmarter"
        class="text-xl md:text-3xl tracking-wide text-center"
      >
        MANAGE SMARTER
      </h2>
      <h2
        i18n="organizer.grow|Get paid faster tagline@@organizer.grow.getPaidFaster"
        class="text-xl md:text-3xl tracking-wide text-center"
      >
        GET PAID FASTER
      </h2>
      <h1
        i18n="organizer.grow|Grow bigger tagline@@organizer.grow.growBigger"
        class="text-4xl md:text-8xl font-bold tracking-wide text-center"
      >
        GROW BIGGER
      </h1>
    </div>
  </div>
</section>
